import Promise from 'bluebird';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import AdAdvertiserCreatePaymentScreen from './AdAdvertiserCreatePaymentScreen.js';
import AnchorAPI from '../../modules/AnchorAPI';

import { operations } from './modules/store';

const mapDispatchToProps = (dispatch, ownProps) => ({
  onComponentDidMount: () => {
    const { params } = ownProps.match;
    if (params.webAdAdvertiserId) {
      dispatch(operations.setIsFetching(true));
      AnchorAPI.fetchAdvertiserById(params.webAdAdvertiserId)
        .then(advertiser => {
          dispatch(operations.setAdvertiserName(advertiser.name));
        })
        .finally(() => {
          dispatch(operations.setIsFetching(false));
        });
    }
  },
  onSubmitPaymentForm: (data, metadata) => {
    const { params } = ownProps.match;
    // return promise to form submit handler
    return AnchorAPI.submitAdvertiserCustomerForm(
      {
        ...data,
        webAdAdvertiserId: params.webAdAdvertiserId,
      },
      metadata
    ).then(() => {
      dispatch(operations.setIsPaymentSuccessful(true));
    });
  },
});

const mapStateToProps = ({
  adAdvertiserCreatePaymentScreen: {
    advertiserName,
    isFetching,
    isPaymentSuccessful,
  },
}) => ({
  advertiserName,
  isFetching,
  isPaymentSuccessful,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdAdvertiserCreatePaymentScreen);
